/**
 * Created by pandemio on 2/22/19.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import {Nav, NavItem, NavLink, Col, Row, TabContent, TabPane, Card, CardTitle, CardText, Button} from 'reactstrap';
import {Translate} from "react-localize-redux";
import classnames from 'classnames';

/**
 * Handle the checkboxes of the countries isos
 */
class PlanList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            planYearList: [],
            planMonthlyList: [],
            activeTab: '1',
            mounted: false
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }

        this.toggle = this.toggle.bind(this);
    }

    /**
     * Mounts the data. Call the data from the server and sets the data to the list
     */
    mountData(){

        // This is promise
        let apiCall = ApiCalls.getCommercialPlans();

        // After the api call, fill the data
        apiCall.then((data)=> {

            for (let i = 0; i < data.Plans.length; i++) {
                if (data.Plans[i].Interval === "year")
                    this.state.planYearList.push(data.Plans[i]);

                if (data.Plans[i].Interval === "month")
                    this.state.planMonthlyList.push(data.Plans[i]);
            }

            this.setState({
                mounted: true
            });
        });
    }

    /**
     * Action when the component will mount
     */
    componentDidMount(){
        this.mountData();
    }

    /**
     * Action when the checkbox changes
     * @param e
     */
    handleSelect(e) {
        this.props.updateParent(e.target.value);
    }


    render() {
        return (
            !this.state.mounted ? null :
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className="btn btn-blue-subscription white-text"
                            onClick={() => { this.toggle('1'); }}>
                            <Translate id="plan.monthly" options={{renderInnerHtml: true}}/>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className="btn btn-orange-subscription white-text"
                            onClick={() => { this.toggle('2'); }}>
                                <Translate id="plan.yearly" options={{renderInnerHtml: true}}/>
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        <Row>
                            {
                                this.state.planMonthlyList.map((item)=> {
                                    return(
                                        <Col sm={{size: 12}} md={{size: 6}} lg={{size: 4}} key={item.Id}>
                                            <Card body>
                                                <CardTitle>
                                                    <h1><b>{item.PlanDescriptionByLang[0].Name}</b></h1>
                                                </CardTitle>
                                                <CardText>
                                                    <span dangerouslySetInnerHTML={{ __html: item.PlanDescriptionByLang[0].Description }}/>
                                                </CardText>
                                                <hr/>
                                                    <span><h1>{item.ClientPrice}</h1>
                                                        <small> <Translate id="plan.per-month" options={{renderInnerHtml: true}}/></small>
                                                    </span>
                                                <Button value={item.Id} color="warning" className="btn-buy font-now-bold" onClick={this.handleSelect}>
                                                        <Translate id="plan.buy-now" options={{renderInnerHtml: true}}/>
                                                </Button>
                                            </Card>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            {
                                this.state.planYearList.map((item)=> {
                                    return(
                                        <Col sm={{size: 12}} md={{size: 6}} lg={{size: 4}} key={item.Id}>
                                            <Card body>
                                                <CardTitle><h1><b>{item.PlanDescriptionByLang[0].Name}</b></h1></CardTitle>
                                                <CardText>
                                                    <span dangerouslySetInnerHTML={{ __html: item.PlanDescriptionByLang[0].Description }}/>
                                                </CardText>
                                                <hr/>
                                                <span><h1>{item.ClientPrice}</h1>
                                                        <small> <Translate id="plan.per-year" options={{renderInnerHtml: true}}/></small>
                                                    </span>
                                                <Button value={item.Id} color="warning" className="btn-buy font-now-bold" onClick={this.handleSelect}>
                                                        <Translate id="plan.buy-now" options={{renderInnerHtml: true}}/>
                                                </Button>
                                            </Card>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </TabPane>
                </TabContent>
                    {
                      //  this.state.planList.map(item => (
                        //    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}} key={item.key}></Col>
                        //))
                    }

            </div>
        );
    }
}

export default PlanList;